window.addEventListener("load", () => {
    document.querySelectorAll(".ms_usps .wrapper.limit-items").forEach(wrapper => {
        const desktopCount = +wrapper.getAttribute("data-desktop") || 3;
        const tabletCount = +wrapper.getAttribute("data-tablet") || 3;
        const mobileCount = +wrapper.getAttribute("data-mobile") || 1;
        const usps = wrapper.querySelectorAll(".usp");

        const getDevice = () =>
            Foundation.MediaQuery.atLeast("lg") ? "desktop" :
            Foundation.MediaQuery.atLeast("sm") ? "tablet" : "mobile";

        const updateVisibility = () => {
            const count = getDevice() === "desktop" ? desktopCount
                        : getDevice() === "tablet" ? tabletCount
                        : mobileCount;
            usps.forEach((el, i) => {
                el.style.display = i < count ? "" : "none";
            });
        };

        updateVisibility();
        $(window).on("changed.zf.mediaquery", updateVisibility);
    });
});
